import { BasePrimaryButton, BasePrimaryButtonProps } from '@practium/ui';
import { SocialButton } from '../SocialButton/SocialButton';
import styles from './AuthButton.module.css';

interface AuthButtonProps extends BasePrimaryButtonProps {
	variant?: 'primary' | 'secondary' | 'social';
}

export const AuthButton = ({
	variant = 'primary',
	className,
	children,
	...props
}: AuthButtonProps) => {
	if (variant === 'social') {
		return (
			<SocialButton className={className} {...props}>
				{children}
			</SocialButton>
		);
	}

	const variantClass = variant === 'secondary' ? styles.secondary : styles.primary;

	return (
		<BasePrimaryButton className={`${variantClass} ${className || ''}`} {...props}>
			{children}
		</BasePrimaryButton>
	);
};
